// extracted by mini-css-extract-plugin
export default {"visuallyhidden":"egress-toggle-button__visuallyhidden--Vdp86","focusable":"egress-toggle-button__focusable--Qfm_J","label":"egress-toggle-button__label--f_297"};